// extracted by mini-css-extract-plugin
export var dataCell = "_qp-2";
export var dataRow = "_qp-0";
export var headerRow = "_qp-1";